<script lang="ts">
  import Button from './Button.svelte';
  let {
    title = 'Nessun risultato',
    message = 'Non ci sono dati per i filtri selezionati.',
    action,
  }: { title?: string; message?: string; action?: () => void } = $props();
</script>

<section class="inline-state empty-state">
  <div>
    <strong>{title}</strong>
    <p>{message}</p>
  </div>
  {#if action}<Button onclick={action}>Rimuovi filtri</Button>{/if}
</section>
